/*
 * Research activities/projects filters
 *
 * 3 AND radio button filters for research topic, application area and research sub topic
 * used on article tags in feed
 * 
 * Last filter for research sub topics is dynamically changed based on
 * selected research topic (also has count dynamically in parenthesis).
 * Sub topics for each research topic are retrieved from CSV-file:
 * ../config/dscience-sub-topics.csv
 * 
 * Developed in prod for now:
 * https://www-int.uio.no/dscience/english/research/activities/
 * (saving of local-dscience.js and local-dscience.less only dists those files)
 * 
 */

class dScience {
  constructor() {
    this.animationTimer = null;
    this.researchSubTopics = {};
    this.lastResearchTopic = null;
    this.lastApplicationArea = null;
    this.fromPopState = false;
  }
  setup() {
    this.init();

    // Dynamically radio button click handlers listening on filter forms
    document.getElementsByClassName("filter-form-research-topics")[0].addEventListener("click", (e) => {
      this.filter(e);
    });
    document.getElementsByClassName("filter-form-application-areas")[0].addEventListener("click", (e) => {
      this.filter(e);
    });
    window.addEventListener("popstate", (e) => {
      this.selectFiltersfromPopStateOrInit();
    });
  }

  async init() {
    // Add and update activities/project visible counter
    const numberOfProjectsHtml = `<p class="filter-number-of-projects" role="status" aria-live="polite"></p>`;
    document.querySelectorAll(".projects-feed")[0].insertAdjacentHTML('afterbegin', numberOfProjectsHtml);
    this.updateCount();
  
    // Retrieve sub topics
    const data = await fetch('/vrtx/dist/resources/config/dscience-sub-topics.csv')
      .then(response => response.text())
      .then(v => this.parseCSV(v))
      .catch(err => console.log(err));
  
    // Move sub topics into categories by CSV header (first line)
    //console.log(data);
    for(var rowNr = 0; rowNr < data.length; rowNr++) {
      let count = 0;
      let key = "";
      data.forEach(row => {
        if(row[rowNr]) { // Ignore empty lines
          const item = row[rowNr].trim();
          if(count > 0) {
            this.researchSubTopics[key].push(item);
          } else {
            key = item;
            key = key.toLowerCase();
            this.researchSubTopics[key] = [];
          }
        }
        count++;
      });
    }
  
    // If page is loaded with filter parameters
    if(location.search != "") {
      this.selectFiltersfromPopStateOrInit();
    }
    //console.log(researchTopicsFilters);
  }

  filter (e) {
    //const t0 = performance.now();
    
    const target = e.target.closest("input[type='radio']");
    if(!target) return;
  
    if(this.animationTimer != null) {
      clearTimeout(this.animationTimer);
    }
  
    let checkedResearchTopic = document.querySelector('input[name="research-topics"]:checked').value.toLowerCase();
    let checkedApplicationArea = document.querySelector('input[name="application-areas"]:checked').value.toLowerCase();
    let checkedSubTopic = "show all";
  
    var liElms = document.querySelectorAll(".projects-feed li");
    const checkSubTopics = this.researchSubTopics[checkedResearchTopic];

    const subTopicCount = {};
    if(checkedResearchTopic !== "show all") {
      console.log(checkSubTopics);
      checkSubTopics.forEach(item => {
        let numFoundWithinSubTopic = 0;
        liElms.forEach(elm => {
          const dataCategories = this.extractDataCategoriesFromListElm(elm);
          if(dataCategories.indexOf(item.toLowerCase()) !== -1 && (dataCategories.indexOf(checkedApplicationArea) !== -1 || checkedApplicationArea === "show all")) {
            numFoundWithinSubTopic++;
          }
        });
        subTopicCount[JSON.stringify(item.toLowerCase())] = numFoundWithinSubTopic;
      });
    }
  
    // Add subtopics filter dynamically, and show how many found for each suptopic radio button in paranthesis
  
    const subTopicsElm = document.querySelectorAll(".subtopics");
    if(checkedResearchTopic !== "show all") {
      if(checkedResearchTopic != this.lastResearchTopic || !subTopicsElm.length) {
        if(subTopicsElm.length) {
          subTopicsElm[0].remove();
        }

        let subTopicsListHtml = "";
        let count = 0;
        const thirds = {
          0: "left",
          1: "middle",
          2: "right"
        }
        this.splitToNChunks([...checkSubTopics], 3).forEach(arr => {
          let arrHtml = "";
          arr.forEach(item => {
            const escapedItemName = this.escapeItemForHtml(item.toLowerCase());
            let numFoundWithinSubTopic = subTopicCount[JSON.stringify(item.toLowerCase())];
            arrHtml += `
            <li>
              
              <label for="subtopics-${escapedItemName}">${item} (<span class="subtopics-count">${numFoundWithinSubTopic}</span>)</label>
            </li>`;
          });
          subTopicsListHtml += `<ul class="thirds-${thirds[count]}">
                                  ${arrHtml}
                                </ul>`;
          count++;
        });

        const rowHtml = `
        <div class="grid-container subtopics">
          <div class="vrtx-frontpage-row row">
            <div class="column-wrapper wide-narrow">
              <div class="vrtx-frontpage-box vrtx-header-false vrtx-more-false" id="vrtx-main-content-2-5">
                <div class="vrtx-box-content">
                  
                    <fieldset><legend>Select subtopic</legend>
                      <p> <label for="subtopics-show-all">Show all subtopics</label></p>
                      ${subTopicsListHtml}
                    </fieldset>
                  
                </div>
              </div>
            </div>
          </div>
        </div>`;
        document.querySelectorAll("#vrtx-main-content .grid-container")[0].insertAdjacentHTML('afterend', rowHtml);
  
        document.getElementsByClassName("filter-form-subtopics")[0].addEventListener("click", (e) => {
          this.filter(e);
        });
      } else {
        // If changes application area, update subtopics found count in paranthesis
        if(this.lastApplicationArea != checkedApplicationArea) {
          checkSubTopics.forEach(item => {
            document.querySelector('label[for="subtopics-' + this.escapeItemForHtml(item.toLowerCase()) + '"] .subtopics-count').innerHTML = subTopicCount[JSON.stringify(item.toLowerCase())];
          });
        }
      }
  
      checkedSubTopic = document.querySelector('input[name="subtopics"]:checked').value.toLowerCase();
  
      this.lastResearchTopic = checkedResearchTopic;
      this.lastApplicationArea = checkedApplicationArea;
    } else {
      if(subTopicsElm.length) {
        subTopicsElm[0].remove();
      }
    }
    checkedSubTopic = checkedSubTopic.toLowerCase();
  
    liElms.forEach(elm => {
      const dataCategories = this.extractDataCategoriesFromListElm(elm);
      const hasApplicationArea = dataCategories.indexOf(checkedApplicationArea) !== -1 || checkedApplicationArea === "show all";
  
      // Check if has sub topic associated with the topic
      let hasTopic = false;
      if(checkSubTopics) {
        checkSubTopics.forEach(item => {
          if(dataCategories.indexOf(item.toLowerCase()) !== -1) {
            hasTopic = true;
          }
        });
      }
      hasTopic = hasTopic || checkedResearchTopic === "show all";
      const hasSubTopic = dataCategories.indexOf(checkedSubTopic) !== -1 || checkedSubTopic === "show all";
  
      if(!hasTopic || !hasApplicationArea || !hasSubTopic) {
        /*elm.classList.add("hidden-project-anim");
        this.animationTimer = setTimeout(function() {*/
          elm.classList.add("hidden-project");
          this.updateCount();
        /*}, 200);*/
      } else {
        elm.classList.remove("hidden-project");
        this.updateCount();
        /*this.animationTimer = setTimeout(function() {
          elm.classList.remove("hidden-project-anim");
        }, 200);*/
      }
    });
  
    if(!this.fromPopState) {
      checkedResearchTopic = this.escapeItemForHtml(checkedResearchTopic);
      checkedApplicationArea = this.escapeItemForHtml(checkedApplicationArea);
      checkedSubTopic = this.escapeItemForHtml(checkedSubTopic);
      const parameters = "?research-topic=" + checkedResearchTopic + "&application-area=" + checkedApplicationArea + "&subtopic=" + checkedSubTopic;
      history.pushState({
        "research-topic": checkedResearchTopic,
        "application-area": checkedApplicationArea,
        "subtopic": checkedSubTopic
      }, "", location.href.replace(/\?.*/, "") + parameters);
    }
    //const t1 = performance.now();
    //console.log(`Filtering took ${t1 - t0}ms`);
  }

  extractDataCategoriesFromListElm(elm) {
    const dataCategories = [];
    elm.getAttribute("data-categories").split(" ").forEach(category => {
      if(category.indexOf("type:" === -1)) { // Ignore type: parts
        category = category.replace(/^[^:]+:/, "").replace(/[_]+/g, " "); // Remove "tag:" from tags and convert underscore to space
        dataCategories.push(category.trim().toLowerCase()); // Convert to not case-sensitive
      }
    });
    return dataCategories;
  }
  selectFiltersfromPopStateOrInit() {
    this.fromPopState = true;
    let checkedResearchTopic = this.gup(location.href, "research-topic") || "show-all";
    let checkedApplicationArea = this.gup(location.href, "application-area") || "show-all";
    let checkedSubTopic = this.gup(location.href, "subtopic") || "show-all";

    document.querySelector("input#research-topics-" + checkedResearchTopic).click();
    document.querySelector("input#application-areas-" + checkedApplicationArea).click();
    setTimeout(() => {
      const subTopicElm = document.querySelector("input#subtopics-" + checkedSubTopic);
      if(subTopicElm) {
        subTopicElm.click();
      }
      this.fromPopState = false;
    }, 1);
  }
  updateCount() {
    const numberOfProjects = document.querySelectorAll(".projects-feed li:not(.hidden-project)").length;
    let numberOfProjectsHtml = `Found no projects`;
    if(numberOfProjects >= 1) {
      numberOfProjectsHtml = `Showing ${numberOfProjects} project`;
    }
    if(numberOfProjects > 1) {
      numberOfProjectsHtml += "s";
    }
    document.getElementsByClassName("filter-number-of-projects")[0].innerHTML = numberOfProjectsHtml;
  }

  // Credits: https://stackoverflow.com/questions/8188548/splitting-a-js-array-into-n-arrays#51514813
  splitToNChunks(array, n) {
    let result = [];
    for (let i = n; i > 0; i--) {
      result.push(array.splice(0, Math.ceil(array.length / i)));
    }
    return result;
  }

  escapeItemForHtml(item) {
    return item.replace(/[ ,\/,\(,\)]+/igm, "-");
  }

  // Credits: https://stackoverflow.com/questions/1293147/how-to-parse-csv-data#8932924
  parseCSV(s,sep) { 
    // http://stackoverflow.com/questions/1155678/javascript-string-newline-character
    var universalNewline = /\r\n|\r|\n/g;
    var a = s.split(universalNewline);
    for(var i in a){
      for (var f = a[i].split(sep = sep || ","), x = f.length - 1, tl; x >= 0; x--) {
        if (f[x].replace(/"\s+$/, '"').charAt(f[x].length - 1) == '"') {
          if ((tl = f[x].replace(/^\s+"/, '"')).length > 1 && tl.charAt(0) == '"') {
            f[x] = f[x].replace(/^\s*"|"\s*$/g, '').replace(/""/g, '"');
          } else if (x) {
            f.splice(x - 1, 2, [f[x - 1], f[x]].join(sep));
          } else f = f.shift().split(sep).concat(f);
        } else f[x].replace(/""/g, '"');
      } a[i] = f;
    }
    return a;
  }

  gup(url, parameterName) {
    parameterName = parameterName.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
    var regex = new RegExp("[\\?&]" + parameterName + "=([^&#]*)");
    var results = regex.exec(url);
    return (results === null) ? null : results[1];
  }
}

let dscience = new dScience();
dscience.setup();